import Vue from 'vue';
import Vuex from 'vuex';

// 该指令必须在 store 创建之前执行
Vue.use(Vuex);

const actions = {
  changeDispatch(context, value) {
    context.commit('changeCommit', value);
  }
};

const mutations = {
  changeCommit(state, value) {
    state.game = value;
    localStorage.setItem('game-info', JSON.stringify(state.game));
  }
};
// State: 用于存储数据
const state = {
  game: {
    ...JSON.parse(localStorage.getItem('game-info'))
  }
};

// 创建并导出 store
export default new Vuex.Store({
  actions,
  mutations,
  state,
});
